import { Link } from "react-router-dom";
import type { VideoItem } from "@/types/video";
import { formatDate, formatViews } from "@/utils/format";

interface VideoCardProps {
  video: VideoItem;
}

export default function VideoCard({ video }: VideoCardProps) {
  return (
    <Link
      to={`/detail/${video.id}`}
      className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
    >
      <div className="relative aspect-video w-full overflow-hidden bg-background-200">
        <img
          src={video.cover}
          alt={video.title}
          title={`${video.title} 高清视频资源`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute right-2 top-2 rounded-md bg-accent-500 px-2 py-0.5 text-xs font-medium text-white">
          {video.quality}
        </span>
        <span className="absolute bottom-2 right-2 rounded-md bg-foreground-950/70 px-2 py-0.5 text-xs text-white">
          {video.duration}
        </span>
      </div>
      <div className="flex flex-1 flex-col gap-2 p-4">
        <h3 className="line-clamp-1 font-heading text-sm font-semibold text-foreground-950 transition-colors group-hover:text-primary-600 md:text-base">
          {video.title}
        </h3>
        <p className="line-clamp-2 text-xs leading-relaxed text-foreground-600 md:text-sm">{video.summary}</p>
        <div className="mt-auto flex items-center justify-between pt-2 text-xs text-foreground-500">
          <span className="flex items-center gap-1">
            <i className="ri-calendar-line"></i>
            {formatDate(video.uploadDate)}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-eye-line"></i>
            {formatViews(video.views)}
          </span>
        </div>
      </div>
    </Link>
  );
}